import { observer } from "mobx-react-lite";
import { Button, Col, Modal, Row, Select, Space } from "antd";
import { useStore } from "../../stores/root-store-context";

export const NewGroupModal = observer(
  (props: {
    isOpenModal: boolean;
    dismissModal: () => void;
    onSave: () => void;
  }) => {
    const { applicationStore } = useStore();
    const { isOpenModal, dismissModal, onSave } = props;
    return (
      <>
        <Modal
          data-testid="mat-modal-new-group"
          title={<h2>Add Committee Group</h2>}
          style={{ top: "5%", padding: 0 }}
          styles={{
            body: {
              height: "100%",
              margin: 5,
              maxWidth: 600,
              padding: 0,
            },
            content: {
              height: "100%",
              padding: 10,
            },
          }}
          open={isOpenModal}
          footer={null}
          onCancel={() => {
            dismissModal();
          }}
        >
          <Row>
            <Col span={24}>
              <Select
                data-testid="mat-select-new-group"
                style={{ width: "100%" }}
                value={applicationStore.additionGroupName}
                showSearch
                virtual={false}
                filterOption={(input, option) =>
                  (option?.label?.toLocaleLowerCase() ?? "").includes(
                    input.toLocaleLowerCase()
                  )
                }
                onChange={(value: string) => {
                  applicationStore.setAdditionGroupName(value);
                }}
                options={applicationStore.additionGroup.map((_) => {
                  return {
                    value: _.availableGroup,
                    label: _.availableGroup,
                  };
                })}
              />
            </Col>
          </Row>
          <Row>
            <Col span={24} style={{ textAlign: "right", marginTop: "16px" }}>
              <Space>
                <Button
                  data-testid="mat-btn-close-group"
                  size="large"
                  onClick={() => {
                    applicationStore.setAdditionGroupName("");
                    dismissModal();
                  }}
                >
                  Close
                </Button>
                <Button
                  data-testid="mat-btn-save-group"
                  size="large"
                  type="primary"
                  onClick={() => {
                    onSave();
                  }}
                >
                  Save Changes
                </Button>
              </Space>
            </Col>
          </Row>
        </Modal>
      </>
    );
  }
);